import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CustomerSurvey } from '@coin/shared/customer-survey/util';
import { HttpHelpersService, LoadingService } from '@coin/shared/core/data-access';
import { environment } from '@coin/shared/core/util-environments';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomerSurveyService {
  private readonly httpClient = inject(HttpClient);
  private readonly loadingService = inject(LoadingService);
  private readonly httpHelpersService = inject(HttpHelpersService);

  public getSurvey(id: string, withLoadingScreen = true): Observable<CustomerSurvey> {
    return this.httpClient
      .get<CustomerSurvey>(`${environment.api.storageService}/v1/position-evaluation/surveys/${id}`)
      .pipe(o$ => (withLoadingScreen ? this.loadingService.withLoadingScreen(o$) : o$));
  }

  public createSurvey(survey: CustomerSurvey): Observable<CustomerSurvey> {
    this.loadingService.present();
    return this.httpClient
      .post<CustomerSurvey>(`${environment.api.storageService}/v1/position-evaluation/surveys`, survey)
      .pipe(
        this.httpHelpersService.handleError('Cannot create survey'),
        finalize(() => this.loadingService.dismiss())
      );
  }

  public updateSurvey(survey: CustomerSurvey): Observable<CustomerSurvey> {
    if (!survey) {
      return this.httpHelpersService.throwError('survey.errors.update');
    }

    this.loadingService.present();
    return this.httpClient
      .patch<CustomerSurvey>(`${environment.api.storageService}/v1/position-evaluation/surveys`, survey)
      .pipe(
        this.httpHelpersService.handleError('Cannot save survey results'),
        finalize(() => this.loadingService.dismiss())
      );
  }

  public deleteSurvey(id: string): Observable<void> {
    this.loadingService.present();
    return this.httpClient.delete<void>(`${environment.api.storageService}/v1/position-evaluation/surveys/${id}`).pipe(
      this.httpHelpersService.handleError('Cannot delete survey'),
      finalize(() => this.loadingService.dismiss())
    );
  }
}
